<template>
  <footer class="footer">
    <p>
      <router-link to="/about">关于我们</router-link> |
      <router-link to="/privacy">隐私政策</router-link> |
      <router-link to="/terms">使用条款</router-link> |
      <router-link to="/disclaimer">免责声明</router-link>
    </p>
    <p class="icp-record">
      <span class="icp-row">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          class="icp-link"
        >沪ICP备2026007994号</a>
        <span class="icp-sep" aria-hidden="true">|</span>
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31010702010047"
          target="_blank"
          rel="noopener noreferrer"
          class="gongan-link"
        >
          <img
            src="/gongan-beian.png"
            alt="公安备案"
            class="gongan-icon"
          />
          沪公网安备31010702010047号
        </a>
      </span>
    </p>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #000;
  color: white;
  text-align: center;
  padding: 20px;
}

.footer a {
  color: #e50914;
  margin: 0 10px;
  text-decoration: none;
}

.icp-record {
  margin-top: 12px;
  margin-bottom: 0;
  font-size: inherit;
  color: #888;
}

.icp-record .icp-link {
  color: #888;
  margin: 0;
  text-decoration: none;
}

.icp-record .icp-link:hover {
  color: #aaa;
  text-decoration: underline;
}

.icp-row {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  justify-content: center;
}

.icp-sep {
  color: #666;
  user-select: none;
}

.icp-record .gongan-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #888;
  margin: 0;
  text-decoration: none;
}

.icp-record .gongan-link:hover {
  color: #aaa;
  text-decoration: underline;
}

.gongan-icon {
  height: 14px;
  width: auto;
  display: block;
  flex-shrink: 0;
}
</style> 